import React, {FC} from 'react';
import IdentityPageLayout from "@/features/identity/components/IdentityPageLayout.tsx";
import TwoFactorLoginForm from "@/features/identity/components/TwoFactorLoginForm.tsx";

const TwoFactorLogin: FC = () => {
    return (
        <IdentityPageLayout>
            <TwoFactorLoginForm/>
        </IdentityPageLayout>
    );
};

export default TwoFactorLogin;
